import Link from 'next/link'
import type React from 'react'
import { UserAvatar } from '@/components/ui'
import type { GetRankingSimpleResponse } from '@/services/http/usersService/rankingSimple'
import { BronzeMedal, GoldMedal, SilverMedal } from '../../icons'
import { Button } from '../button'
import { Card, CardContent } from '../card'

type RankingProps = {
  items: GetRankingSimpleResponse['usersRanking']
  viewAllUrl: string
}

const Ranking: React.FC<RankingProps> = ({ items, viewAllUrl }) => {
  const medals = [
    <GoldMedal key="gold" />,
    <SilverMedal key="silver" />,
    <BronzeMedal key="bronze" />,
  ]

  return (
    <Card>
      <CardContent className="flex flex-col gap-3 p-4">
        {items.map((item, index) => (
          <div
            key={item.id}
            className="flex items-center justify-between gap-10 border-b border-system-border-secondary px-4 py-2"
          >
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <span className="w-8 text-right font-montserrat text-xl font-bold text-system-text-primary">
                  {index < medals.length ? medals[index] : `${index + 1}º`}
                </span>
                <UserAvatar
                  src={item.image || ''}
                  name={item.name}
                  className="size-8"
                />
              </div>
              <span className="text-sm font-medium text-system-text-primary">
                {item.name}
              </span>
            </div>

            <div className="flex flex-col items-center gap-1 text-xs font-bold">
              <span>Pontos</span>
              <span>{item.points}</span>
            </div>
          </div>
        ))}
        <div className="cursor-pointer text-right">
          <Button variant="link" size="link" asChild>
            <Link href={viewAllUrl}>Ver tudo</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}

Ranking.displayName = 'Ranking'

export { Ranking }
